import { render, staticRenderFns } from "./SynergridRemoveRequestForm.vue?vue&type=template&id=343b2f5e"
import script from "./SynergridRemoveRequestForm.vue?vue&type=script&lang=ts"
export * from "./SynergridRemoveRequestForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports